import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

const sentrySettings = {
  environment: process.env.NODE_ENV,
  release: process.env.BUILD_VERSION.replace('/', '-'),
  dsn: 'https://b1e308e0ec2543c590dc8fb3c7e57f09@o49094.ingest.sentry.io/5424415',
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      logErrors: true
    }),
    new Integrations.BrowserTracing()
  ],
  tracesSampleRate: 0.01,
  beforeBreadcrumb (breadcrumb, hint) {
    // Filter console log in non production envs as it overflows the request and exceeds its limit
    if (process.env.NODE_ENV !== 'production') {
      return null
    }
    return breadcrumb
  }
}

if (['production', 'staging'].includes(process.env.NODE_ENV)) {
  Sentry.init(sentrySettings)
}
